// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/information-small/information-small.scss
 ** module id = 153
 ** module chunks = 0 1
 **/